import axios from 'axios';
import store from '@/store';
import conf from '@/aws-configuration';

const apiUrl = conf.endpoint;

let idToken;

// TODO: replace with axios interceptors

async function guardRequest(type, path, data) {
    idToken = store.state.tokens.id_token;
    const options = {
        headers: {
            Authorization: idToken,
        },
    };

    switch (type) {
    default:
    case 'get': return axios.get(`${apiUrl}${path}`, options);
    case 'post': return axios.post(`${apiUrl}${path}`, data, options);
    case 'put': return axios.put(`${apiUrl}${path}`, data, options);
    case 'delete': return axios.delete(`${apiUrl}${path}`, { data, ...options });
    }
}

export default {
    getRoles() {
        return guardRequest('get', '/getroles');
    },
    searchUsers(query) {
        query = encodeURIComponent(query);
        return guardRequest('get', `/searchusers?search=${query}`);
    },
    searchEclassCourses(query) {
        return guardRequest('get', `/searcheclasscourses?query=${query}`);
    },
    searchExternalCourses(query) {
        return guardRequest('get', `/searchexternalcourses?query=${query}`);
    },
    searchCourseShortName(name, server) {
        return guardRequest('get', `/searchshortnameexists?name=${name}&server=${server}`);
    },
    getTerms() {
        return guardRequest('get', '/getterms');
    },
    getSubjects(code) {
        return guardRequest('get', `/getsubjects?term=${code}`);
    },
    getCatalogNumbers(code, name) {
        return guardRequest('get', `/getcatalognumbers?term=${code}&subject=${name}`);
    },
    getSections(code, name, catalogNumber) {
        return guardRequest('get', `/getsections?term=${code}&subject=${name}&catalognbr=${catalogNumber}`);
    },
    cohortQueueStatus() {
        return guardRequest('get', '/cohortstatus');
    },
    cohortSync(cohort) {
        return guardRequest('post', '/cohortsync', { cohort });
    },
    cohortRelease(cohort) {
        return guardRequest('post', '/cohortrelease', { cohort });
    },
    cohortCreate(cohort) {
        return guardRequest('post', '/cohortcreate', { cohort });
    },
    cohortExcludeSync(cohort) {
        return guardRequest('post', '/cohortexcludesync', { cohort });
    },
    getInstructorEclassCourses(ccid) {
        return guardRequest('get', `/getinstreclasscourses?ccid=${ccid}`);
    },
    getSandboxId(ccid) {
        return guardRequest('get', `/getsandboxid?ccid=${ccid}`);
    },
    getInstructorEclassCoursesByTerm(ccid, term) {
        return guardRequest('get', `/getinstrclassesbyccidterm?term=${term}&ccid=${ccid}`);
    },
    submitCourseRequest(courseRequests) {
        return guardRequest('post', '/save', courseRequests);
    },
    submitCanvasSandboxRequest(courseRequests) {
        return guardRequest('post', '/canvas/sandbox', courseRequests);
    },
    submitCanvasCourseRequest(courseRequest) {
        return guardRequest('post', '/canvas/course-request', courseRequest);
    },
    getRequests(query) {
        query = query || '';
        return guardRequest('get', `/getrequests?${query}`);
    },
    getCanvasCourseRequests(query) {
        query = query || '';
        return guardRequest('get', `/canvas/courserequests?${query}`);
    },
    getCanvasRequestorRequests(query) {
        query = query || '';
        return guardRequest('get', `/canvas/requestorrequests?${query}`);
    },
    getSecurityRequests() {
        return guardRequest('get', '/getsecurityrequests');
    },
    getCanvasConsentRequests() {
        return guardRequest('get', '/canvas/consentrequests');
    },
    getTermStatistics(termId) {
        return guardRequest('get', `/canvas/term-statistics?termId=${termId}`);
    },
    getCategories() {
        return guardRequest('get', '/getcategories');
    },
    submitApproval(params) {
        return guardRequest('post', '/approval', params);
    },
    editCanvasCreditCourseRequest(courseRequest) {
        return guardRequest('put', '/canvas/edit', courseRequest);
    },
    submitCanvasCreditConsent(params) {
        return guardRequest('put', '/canvas/confirmOrDenyRequests', params);
    },
    deleteRequest(params) {
        return guardRequest('post', '/delete', params);
    },
    canvasDeleteRequest(params) {
        return guardRequest('delete', '/canvas/course', params);
    },
    canvasResetCourseContent(params) {
        return guardRequest('post', '/canvas/reset-content', params);
    },
    editRequest(params) {
        return guardRequest('post', '/edit', params);
    },
    setAccess(params) {
        return guardRequest('post', '/setaccess', params);
    },
    getAccess(params) {
        return guardRequest('get', '/getaccess', params);
    },
    getMoodleStatus() {
        return guardRequest('get', '/getmoodlestatus');
    },
    exchangeCodeForTokens(params) {
        const { code } = params;
        return axios.get(`${apiUrl}/oauthlanding?code=${code}`);
    },
    refreshTokens(params) {
        // eslint-disable-next-line camelcase
        const { refresh_token } = params;
        // eslint-disable-next-line camelcase
        return axios.get(`${apiUrl}/oauthrefresh?refresh_token=${refresh_token}`);
    },
    /**
     *
     * @param {*} cohorts format: { cohorts: [{strm: num, class_nbr: num }]}
     */
    async generateDefaultFullName(cohorts) {
        return guardRequest('post', '/generatedefaultfullname', cohorts);
    },

    async getCanvasSections(term, subject) {
        return guardRequest('get', `/canvas/sections?term=${term}&subject=${subject}`);
    },

    async getCanvasUserCourses() {
        return guardRequest('get', '/canvas/user-courses');
    },

    async getCanvasInstrCourses(term) {
        return guardRequest('get', `/canvas/instr-courses?term=${term}`);
    },

    async getCanvasDefaultTemplate() {
        return guardRequest('get', '/canvas/default-template');
    },
};
